import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccessTokenService } from '../services/authentication/access-token.service';
import { environment } from '../../../environments/environment';

export const authGuard: CanActivateFn = () => {
  if (environment.swapId) return true;

  const accessToken = inject(AccessTokenService);

  if (accessToken.getToken()) {
    return true;
  }

  const ssoUrl = environment.bbvaSso;
  const currentPath = window.location.pathname;
  localStorage.setItem('path', currentPath);
  window.location.href = `${ssoUrl}${currentPath}`;
  return false;
};
